<template>
  <div ref="wrapper">
    <slot />
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'

const wrapper = ref<HTMLDivElement|undefined>()

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = defineProps({
  padding: { type: Boolean, default: false }
})

onMounted(() => {
  if (props.padding && wrapper.value) {
    wrapper.value.classList.add('site-page')
    wrapper.value.classList.add('q-mt-md')
  }
})
</script>
<style lang="scss" scoped>
.site-page {
  padding: 4px;
  @media (min-width: $breakpoint-sm-max) {
    padding: 8px;
  }
}
</style>
